var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loginbg",
      staticStyle: { display: "none" },
      attrs: { id: "login-main-hr" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
            _c("div", { staticClass: "loginform" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { id: "ResetPasswordUserForm", name: "form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.attemptResetPassword()
                    }
                  }
                },
                [
                  _c("h2", [_vm._v(" Reset Password ")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        name: "password",
                        id: "password",
                        placeholder: ""
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.frontendErrors.password))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cpassword,
                          expression: "cpassword"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        name: "cpassword",
                        id: "cpassword",
                        placeholder: ""
                      },
                      domProps: { value: _vm.cpassword },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.cpassword = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.frontendErrors.cpassword))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3"
                    },
                    [
                      _c("font", { staticClass: "text-danger" }, [
                        _c("label", {
                          staticClass: "error text-danger",
                          attrs: { id: "errorMsg" }
                        }),
                        _c("br")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          disabled: _vm.disableButtons.submitButton,
                          id: "sendEmail"
                        }
                      },
                      [_vm._v(_vm._s(_vm.buttonNames.submitButton))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          disabled: _vm.disableButtons.backButton
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.backBtn()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.buttonNames.backButton))]
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loginlogo" }, [
      _c("img", {
        attrs: {
          src: "/static/images/login-logo.png",
          alt: "Velocity Vehicle Group"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "username" } }, [
      _vm._v("Password"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "username" } }, [
      _vm._v("Confirm Password"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1ed298e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ed298e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/UserResetPassword.vue
// module id = null
// module chunks = 